import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';

// import { City } from '@app/core/models';

@Injectable({ providedIn: 'root' })
export class HospitalService {

  constructor(private http: ApplicationHttpClient) {
  }

  public getHospitals(cityCode): Observable<any> {
    return this.http.get(`/api/app/hospital/city/${ cityCode }`).pipe(
      map(hospitals => {
        return hospitals.items.map(hospital => ({
          ...hospital,
          name: `${ hospital.id } - ${ hospital.name }`,
          shortName: hospital.code
        }));
      })
    );
  }

  public searchHospital(cityCode, name = ''): Observable<any> {
    return this.http.get('/api/app/hospital', {
      params: {
        cityCode,
        name
      }
    }).pipe(
      map(hospitals => {
        return hospitals.items.map(hospital => ({
          ...hospital,
          name: `${ hospital.id } - ${ hospital.name }`,
          shortName: hospital.code
        }));
      })
    );
  }

  public getById(id): Observable<any> {
    return this.http.get(`/api/app/hospital/code?code=${id}`);
  }

  public create(body, options = {}) {
    return this.http.post('/api/app/hospital', body, options);
  }
}
